export const FIRESTORE_COLLECTIONS = Object.freeze({
  ORGANIZATIONS: "organizations",
  VESSELS: "vessels",
  VESSEL_PARTICULARS: "vesselParticulars",
  TANKS: "tanks",
  VOYAGES: "voyages",
  TRIPS: "trips",
  CARGOS: "cargos",
  TANK_MEASUREMENTS: "tankMeasurements",
  STATEMENT_OF_FACT: "statementOfFact",
  SLOP_REPORTS: "slopReports",
  BARGE_LOGS: "bargeLogs",
  DOCUMENTS: "documents",
  AUDIT_ENTRIES: "auditEntries",
});

export const FIRESTORE_V2_STORAGE_MARKER_FIELD = "storageModel";
export const FIRESTORE_V2_STORAGE_MARKER_VALUE = "oceanlogix-v2";
